'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _fade = require('../internal/fade');

var _fade2 = _interopRequireDefault(_fade);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  lightbox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    pointerEvents: 'none',
    paddingTop: '56px'
  },
  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    zIndex: 1
  },
  image: {
    maxWidth: '90%',
    maxHeight: '90%',
    pointerEvents: 'all',
    borderRadius: '4px',
    boxShadow: _styles2.default.depthShadows[0],
    backgroundColor: _colors2.default.background,
    color: _colors2.default.primaryText
  },
  clickAway: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    cursor: 'pointer'
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: '16px 56px',
    color: _colors2.default.white,
    fontSize: '18px',
    fontWeight: 'bolder',
    lineHeight: '24px',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: (0, _fade2.default)(_colors2.default.black, 0.4),
    textAlign: 'center',
    pointerEvents: 'all',
    height: '56px'
  }
};
module.exports = exports.default;